import React, { Fragment, useEffect } from "react";
import SelectField from "./SelectField";
import TextField from "./TextField";
import { showNotification } from "./../../../utils";
import {
    changeClinicNameAll,
    changeAddressAll,
    changeCityAll,
    changeZipAll,
    changeMainAll,
    changeFaxAll,
} from "./../CanvasActions";

const Form = React.memo((props) => {
    useEffect(() => {
        changeClinicNameAll(props.clinicName);
    }, [props.clinicName]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeMainAll(props.main);
    }, [props.main]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    if (props.brochure == null) {
        return null;
    }

    let typeField = null;
    let brochureField = null;
    let previewButton = null;

    const previewHandler = () => {
        if (props.quantity === "") {
            return showNotification(
                "Complete Information",
                "Enter a quantity",
                "info"
            );
        }

        let variables = [
            "templateCode=" + encodeURIComponent("p16bt1"),
            "brochureType=" + encodeURIComponent(props.type),
            "clinicName=" + encodeURIComponent(props.clinicName),
            "address=" + encodeURIComponent(props.address),
            "city=" + encodeURIComponent(props.city),
            "zip=" + encodeURIComponent(props.zip),
            "main=" + encodeURIComponent(props.main),
            "fax=" + encodeURIComponent(props.fax),
        ];

        window.open(
            process.env.REACT_APP_API_URL +
                "/uthealth-order/preview?" +
                variables.join("&")
        );
    };

    let bullet1 = null;
    if (props.brochure.bullet1) {
        bullet1 = <li>{props.brochure.bullet1}</li>;
    }

    let bullet2 = null;
    if (props.brochure.bullet2) {
        bullet2 = <li>{props.brochure.bullet2}</li>;
    }

    let bullet3 = null;
    if (props.brochure.bullet3) {
        bullet3 = <li>{props.brochure.bullet3}</li>;
    }

    let bullet4 = null;
    if (props.brochure.bullet4) {
        bullet4 = <li>{props.brochure.bullet4}</li>;
    }

    let bullet5 = null;
    if (props.brochure.bullet5) {
        bullet5 = <li>{props.brochure.bullet5}</li>;
    }

    let bullet6 = null;
    if (props.brochure.bullet6) {
        bullet6 = <li>{props.brochure.bullet6}</li>;
    }

    let bullet7 = null;
    if (props.brochure.bullet7) {
        bullet7 = <li>{props.brochure.bullet7}</li>;
    }

    let bullet8 = null;
    if (props.brochure.bullet8) {
        bullet8 = <li>{props.brochure.bullet8}</li>;
    }

    const changeNotesHandler = (event) => {
        props.setNotes(event.target.value);
    };

    const addToCartHandler = (type = 1) => {
        if (props.quantity === "") {
            return showNotification(
                "Complete Information",
                "Enter a quantity",
                "info"
            );
        }

        if (
            (props.otherLocation && props.clinicName === "") ||
            (!props.otherLocation && props.clinicId === "")
        ) {
            return showNotification(
                "Complete Information",
                "Enter a Clinic Name",
                "info"
            );
        }

        if (props.otherLocation && props.yourLocation === "") {
            return showNotification(
                "Complete Information",
                "Enter your location",
                "info"
            );
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    let buttonLabel = "Add this to cart";
    if (props.addingToCart) {
        buttonLabel = (
            <Fragment>
                <i className="fas fa-circle-notch fa-spin" /> Adding to Cart...
            </Fragment>
        );
    }

    let saveWorkLabel = "Save Work";
    if (props.savingWork) {
        saveWorkLabel = (
            <Fragment>
                <i className="fas fa-circle-notch fa-spin" /> Saving...
            </Fragment>
        );
    }

    let quantityOptions = [{ value: "", label: "Select option" }];
    quantityOptions.push({ value: 1, label: "1 Bundle (250 pieces)" });
    for (let i = 2; i <= 10; i++) {
        quantityOptions.push({
            value: i,
            label: i + " Bundles (" + 250 * i + " pieces)",
        });
    }

    let informationContent = (
        <Fragment>
            <div className="mt-3">Title: {props.brochure.name}</div>
            <div className="mt-3">UT Physicians - A Part of UTHealth</div>
            <div className="mt-3">
                HEALTHY EATING AND PHYSICAL ACTIVITY TIPS to manage your weight.
            </div>
            <div className="mt-3 mb-3">
                <div className="fact">
                    <i className="far fa-check-square" /> HOW DO I KNOW IF I
                    NEED TO MAINTAIN OR LOSE WEIGHT?
                </div>
                <div className="fact">
                    <i className="far fa-check-square" /> FIND YOUR HEALTHY
                    EATING STYLE.
                </div>
                <div className="fact">
                    <i className="far fa-check-square" /> BE ACTIVE YOUR WAY.
                </div>
            </div>
        </Fragment>
    );
    let legalNoticesSelect = null;
    if (parseInt(props.brochure.id) === 2) {
        quantityOptions = [
            { value: "", label: "Select option" },
            { value: 250, label: 250 },
            { value: 500, label: 500 },
            { value: 750, label: 750 },
            { value: 1000, label: 1000 },
        ];

        informationContent = (
            <Fragment>
                <div className="mt-3">
                    <b>Title:</b>
                    <br />
                    {props.brochure.name}
                </div>
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    {props.brochure.description}
                </div>
            </Fragment>
        );
    } else if (
        [3, 4, 5, 6, 7, 9, 10, 13, 14].includes(parseInt(props.brochure.id))
    ) {
        quantityOptions = [{ value: "", label: "Select option" }];
        for (let i = 1; i <= 10; i++) {
            quantityOptions.push({ value: i, label: i });
        }

        const handleChangeLegalNotices = (event) => {
            props.history.push("/brochure/16/419/" + event.target.value);
        };

        legalNoticesSelect = (
            <div class="variable">
                <div class="label">
                    Legal Notices <span class="required">*</span>:
                </div>
                <select
                    value={props.brochure.id}
                    onChange={handleChangeLegalNotices}
                >
                    <option value="">Select option</option>
                    <option value="3">
                        Patient Rights and Responsibilities (English)
                    </option>
                    <option value="4">
                        Patient Rights and Responsibilities (Spanish)
                    </option>
                    <option value="5">Complaints</option>
                    <option value="7">Privacy Notice</option>
                    <option value="9">
                        Your Rights and Protections Against Surprise Medical
                        Bills
                    </option>
                    <option value="10">
                        UT Good Faith Estimate Notice with QR codes
                    </option>
                    <option value="13">Notice of Nondiscrimination</option>
                    <option value="14">Language Assistance Services</option>
                </select>
            </div>
        );

        let descriptionContaier = null;
        if (parseInt(props.brochure.id) === 13) {
            descriptionContaier = (
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    <div>
                        This informative poster outlines UTHealth Houston and UT
                        Physicians' commitment to compliance with Federal civil
                        rights laws, providing details on nondiscrimination
                        practices and available services. It includes
                        information about reasonable modifications, auxiliary
                        aids, and language assistance for individuals with
                        disabilities or limited English proficiency. The poster
                        also provides clear instructions for filing grievances
                        or complaints regarding discrimination. Should be
                        displayed in all clinic lobbies. Meets Section 1557
                        requirements.
                    </div>
                </div>
            );
        } else if (parseInt(props.brochure.id) === 14) {
            descriptionContaier = (
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    <div>
                        This poster informs patients of their rights to free
                        language assistance services, including interpreters,
                        translation, sign language, and auxiliary aids, provided
                        by university-contracted services. It includes
                        guidelines on requesting assistance and clarifies that
                        family members or friends cannot act as translators for
                        medical communication. Should be displayed in clinic
                        lobbies. Meets Section 1557 requirements.
                    </div>
                </div>
            );
        }

        informationContent = (
            <Fragment>
                <div className="mt-3">
                    <b>Title:</b> {props.brochure.name}
                </div>
                <div>
                    <b>Type:</b> Framed Poster
                </div>
                {descriptionContaier}
            </Fragment>
        );
    } else if (parseInt(props.brochure.id) === 8) {
        quantityOptions = [{ value: "", label: "Select option" }];
        quantityOptions.push({ value: 1, label: "1 Bundle (50 pieces)" });
        for (let i = 2; i <= 10; i++) {
            quantityOptions.push({
                value: i,
                label: i + " Bundles (" + 50 * i + " pieces)",
            });
        }

        informationContent = (
            <Fragment>
                <div className="mt-3">
                    <b>Title:</b>
                    <br />
                    {props.brochure.name}
                </div>
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    {props.brochure.description}
                </div>
            </Fragment>
        );
    } else if (parseInt(props.brochure.id) === 11) {
        quantityOptions = [{ value: "", label: "Select option" }];
        quantityOptions.push({ value: 250, label: "250" });
        quantityOptions.push({ value: 500, label: "500" });
        quantityOptions.push({ value: 1000, label: "1000" });

        informationContent = (
            <Fragment>
                <div className="mt-3">
                    <b>Title:</b>
                    <br />
                    {props.brochure.name}
                </div>
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    {props.brochure.description}
                </div>
            </Fragment>
        );
    } else if (parseInt(props.brochure.id) === 12) {
        quantityOptions = [{ value: "", label: "Select option" }];
        quantityOptions.push({ value: 250, label: "250" });
        quantityOptions.push({ value: 500, label: "500" });
        quantityOptions.push({ value: 1000, label: "1000" });
        quantityOptions.push({ value: 1500, label: "1500" });

        typeField = (
            <SelectField
                required
                label="Options"
                value={props.type}
                setFunction={props.setType}
                options={[
                    { value: "1", label: "Standard" },
                    { value: "2", label: "Custom address" },
                ]}
            />
        );

        informationContent = (
            <Fragment>
                <div className="mt-3">
                    <b>Title:</b>
                    <br />
                    {props.brochure.name}
                </div>
                <div className="mt-3 mb-3">
                    <b>Description:</b>
                    <br />
                    {props.brochure.description}
                </div>
            </Fragment>
        );

        if (parseInt(props.type) === 2) {
            previewButton = (
                <div>
                    <button type="button" className="" onClick={previewHandler}>
                        Preview
                    </button>
                </div>
            );

            brochureField = (
                <Fragment>
                    <hr />
                    <TextField
                        label="Clinic Name"
                        limit={42}
                        showCount
                        value={props.clinicName}
                        setFunction={props.setClinicName}
                    />
                    <TextField
                        label="Address, Suite"
                        limit={41}
                        showCount
                        value={props.address}
                        setFunction={props.setAddress}
                    />
                    <TextField
                        label="City"
                        value={props.city}
                        setFunction={props.setCity}
                    />
                    <TextField
                        label="Zip"
                        value={props.zip}
                        setFunction={props.setZip}
                    />
                    <TextField
                        label="Main number"
                        value={props.main}
                        setFunction={props.setMain}
                    />
                    <TextField
                        label="Fax"
                        value={props.fax}
                        setFunction={props.setFax}
                    />
                    <hr />
                </Fragment>
            );
        }
    }

    let favoriteClasses = ["favorite-container"];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push("active");
        favoriteIcon = <i className="fas fa-heart filled-heart" />;
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let shoppingCartButton = (
        <button
            type="button"
            className="add-to-cart"
            disabled={props.addingToCart}
            onClick={addToCartHandler.bind(this, 1)}
        >
            {buttonLabel}
        </button>
    );
    if (props.action === "edit") {
        shoppingCartButton = null;
    }

    return (
        <div className="form-container">
            <h5>Description</h5>
            <div
                className={favoriteClasses.join(" ")}
                onClick={handleAddFavorite}
            >
                {favoriteIcon} Favorites
            </div>
            <form action="">
                <div className="description-section">
                    {informationContent}
                    <div className="description-list">
                        <div>
                            <b>Detail:</b>
                        </div>
                        <ul>
                            {bullet1}
                            {bullet2}
                            {bullet3}
                            {bullet4}
                            {bullet5}
                            {bullet6}
                            {bullet7}
                            {bullet8}
                        </ul>
                    </div>
                </div>
                {legalNoticesSelect}
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={quantityOptions}
                />
                {typeField}
                {brochureField}
                <div className="variable notes-field">
                    <div className="label">Notes:</div>
                    <textarea
                        value={props.notes}
                        onChange={changeNotesHandler}
                    />
                </div>
            </form>
            <div className="buttons-container">
                {previewButton}
                <button
                    type="button"
                    className="saving-work"
                    onClick={addToCartHandler.bind(this, 2)}
                    disabled={props.savingWork}
                >
                    {saveWorkLabel}
                </button>
                {shoppingCartButton}
            </div>
        </div>
    );
});

export default Form;
